/** A new document's one artboard (points): a 1920 × 1080 screen. */
export const NEW_ARTBOARD = { width: 1920, height: 1080 } as const;
